var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "通过审核",
        visible: _vm.visible,
        "append-to-body": "",
        width: "500px"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "orgForm",
          attrs: {
            model: _vm.ruleForm,
            size: "small",
            rules: _vm.rules,
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "公证员" } },
            [
              _c("el-input", {
                attrs: { disabled: "", placeholder: "公证员名称" },
                model: {
                  value: _vm.ruleForm.notaryPublic,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "notaryPublic", $$v)
                  },
                  expression: "ruleForm.notaryPublic"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公证视频", prop: "videoUrl" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.ruleForm.videoUrl,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "videoUrl", $$v)
                    },
                    expression: "ruleForm.videoUrl"
                  }
                },
                _vm._l(_vm.userList, function(item) {
                  return _c("el-option", {
                    key: item.name,
                    attrs: { label: item.name, value: item.url }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "tip",
              staticStyle: { "padding-left": "30px", "line-height": "1.3" }
            },
            [
              _vm._v(
                "\n      提示：请在已经上传过公证告知视频的公证员中选择一位，此选择将作为本项线上公证告知视频播放者和卷宗默认受理者，请及时通知该公证员！\n    "
              )
            ]
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    disabled: _vm.ruleForm.videoUrl === ""
                  },
                  on: { click: _vm.play }
                },
                [_vm._v("预览视频")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v("通过审核")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("VideoPlayer", { ref: "videoPlayer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }